module.exports = __webpack_public_path__ + "img/logo.fa328098.png";